<template>
  <v-navigation-drawer
    close-on-click
    v-if="['xs', 'sm'].includes($size)"
    right
    :value="value"
    @input="$emit('input', $event)"
    app
    width="100%"
    class="nav-drawer"
    hide-overlay
  >
    <v-list dense class="sidebar">
      <v-list-item link to="/" exact>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/agenda">
        <v-list-item-content>
          <v-list-item-title>Agenda</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/networking">
        <v-list-item-content>
          <v-list-item-title>Networking</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/resources">
        <v-list-item-content>
          <v-list-item-title>Resources</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/stories">
        <v-list-item-content>
          <v-list-item-title>Photos & Stories</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/chat">
        <v-list-item-content>
          <v-list-item-title>Chat</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="currentUser" link @click="logout()">
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    value: Boolean
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
      this.$emit("input", !this.value);
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar {
  ::v-deep .v-list-item__title {
    font-size: 16px;
    line-height: 1.6em;
    text-align: center;
  }

  .v-list {
    padding-top: 10px;
  }

  .v-list-item__content {
    padding: 20px 0;
  }

  .v-list-item__title {
    font-family: $body-font-family, sans-serif;
    font-weight: 800;
    font-size: 20px;
    line-height: 1.167;
    color: white;
    letter-spacing: -0.02em;
  }
}

.theme--light.v-navigation-drawer.nav-drawer {
  top: 60px !important;
  background-color: $primary;
  border-bottom: red 22px solid !important;
  height: calc(100vh - 60px) !important;
}

@media screen and (max-width: 375px) {
  .sidebar {
    .v-list-item__title {
      font-size: 5.3vw;
    }
  }
}
</style>
